import React, {useCallback} from 'react'
import {ButtonLink, TrashBinIcon} from '@modifi/ui'

type DeleteDirectorButtonProps = {
  onClick: () => void
  externalPersonId: string
}

const DeleteDirectorButton: React.FC<DeleteDirectorButtonProps> = ({onClick, externalPersonId}) => {
  const handleClick = useCallback(
    (e: React.UIEvent) => {
      e.preventDefault()
      onClick()
    },
    [onClick]
  )

  return (
    <ButtonLink
      onClick={handleClick}
      iconOnly
      transparent
      type="button"
      data-target="open-delete-director-dialog"
      data-external-id={externalPersonId}
    >
      <TrashBinIcon />
    </ButtonLink>
  )
}

export default DeleteDirectorButton
